import { createRoot } from 'react-dom/client';
import './styles/globals.css';
import { RouterProvider } from 'react-router';
import { Router } from 'components/routing';

createRoot(document.getElementById('root')!).render(<RouterProvider router={Router()} />);

// Prevent full browser reload when HMR updates reach the entry (e.g. non-React host or
// workspace package changes). Re-executes this module instead, re-mounting the app.
// Safe in production: import.meta.hot is undefined outside dev, so this block never runs.
if (import.meta.hot) {
  import.meta.hot.accept();
}
